'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardList = function CardList(_ref) {
    var paymentMethods = _ref.paymentMethods,
        selectedPaymentMethod = _ref.selectedPaymentMethod,
        onPaymentSelectionChanged = _ref.onPaymentSelectionChanged,
        handleRemovePaymentMethod = _ref.handleRemovePaymentMethod,
        isAccount = _ref.isAccount;
    return _react2.default.createElement(
        'div',
        { className: 'list-group mb-10 ml-20 mr-20 list-group-new mt-3' },
        paymentMethods.map(function (paymentMethod, idx, array) {

            var isChecked = selectedPaymentMethod == idx;

            var iconClass = '';

            if (paymentMethod.paymentMethodId == "googlePay") {
                iconClass = "fa fa-google fa-lg icon-m-r-8";
            } else if (paymentMethod.paymentMethodId == "applePay") {
                iconClass = "fa fa-apple fa-lg icon-m-r-8";
            } else {
                iconClass = "fa fa-credit-card-alt icon-m-r-8";
            }

            return _react2.default.createElement(
                'li',
                { key: 'pm' + idx },
                _react2.default.createElement(
                    'div',
                    { className: 'radio newCardItem-radio' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'pmi' + idx, className: 'container-radio address-width-ctrl delivery-address-width-ctrl cart-header' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement('i', { className: iconClass, 'aria-hidden': 'true' }),
                            paymentMethod.maskedNumber
                        ),
                        _react2.default.createElement('input', {
                            id: 'pmi' + idx,
                            type: 'radio',
                            name: 'optradio',
                            title: 'optradio',
                            value: idx,
                            checked: isChecked,
                            onChange: onPaymentSelectionChanged,
                            tabIndex: 18
                        }),
                        _react2.default.createElement('span', { className: 'checkmark-radio' })
                    )
                )
            );
        })
    );
};

exports.default = CardList;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/payment/CardList.jsx
// module id = 715
// module chunks = 0